import React, { useState } from "react";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Input,
    Button,
    Table,
    Badge,
    FormGroup,
    Label
} from "reactstrap";

const ProductSearch = () => {
    // State for search filters
    const [searchFilters, setSearchFilters] = useState({
        marque: "",
        modele: "",
        motorisation: "",
        immatriculation: "",
        categorie: ""
    });

    // State for selected category
    const [selectedCategory, setSelectedCategory] = useState("");

    // Sample products data
    const [products] = useState([
        {
            id: 1,
            marque: "BOSCH",
            reference: "B9K903",
            description: "Kit de plaquettes de frein, frein à cliqueur AP+",
            prix: "18,00€ TTC",
            stock: 1,
            location: "ARA MUSAMOUL"
        },
        {
            id: 2,
            marque: "ATE",
            reference: "223775",
            description: "Kit de plaquettes de frein, frein à cliqueur NR",
            prix: "20,00€ TTC",
            stock: 3,
            location: "ARA GLO"
        },
        {
            id: 3,
            marque: "DELPHI",
            reference: "WAV23597",
            description: "Système de freinage complet",
            prix: "45,00€ TTC",
            stock: 2,
            location: "ARA SUD"
        }
    ]);

    // Brand filter options
    const brandFilters = [
        "A.B.S.",
        "ABNI",
        "ABA+",
        "ASHKA",
        "ATE",
        "BEWUK Braking",
        "BLUE BRUT",
        "BOAG & BECK",
        "BOSCH",
        "BREAD",
        "CLAS",
        "CHAMPION",
        "DELPHI",
        "DEVICERMANN",
        "DENIS",
        "FEIB BUSTEN",
        "FEROOD",
        "PORTAIN"
    ];

    // Categories
    const categories = [
        { name: "Lubrifiants & Antigels", icon: <i className="ri ri-oil-line" /> },
        { name: "Batteries", icon: <i className="ri ri-battery-line" /> },
        { name: "Visibilité", icon: <i className="ri ri-eye-line" /> },
        { name: "Outillages", icon: <i className="ri ri-tools-line" /> },
        { name: "Additifs", icon: <i className="ri ri-add-line" /> },
        { name: "Entretiens & Nettoyage", icon: <i className="ri ri-list-check" /> }
    ];

    const handleFilterChange = (e: any) => {
        const { name, value } = e.target;
        setSearchFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };

    return (
        <React.Fragment>
            <div className="page-content pb-0">
                <Container fluid className="py-3">
                    {/* Search Filters Card */}
                    <Card className="mb-4 shadow-sm">
                        <CardBody>
                            <Row className="g-3">
                                {/* Marque */}
                                <Col md={2}>
                                    <FormGroup>
                                        <Label className="small text-muted">Marque</Label>
                                        <div className="input-group">
                                            <span className="input-group-text bg-light">
                                                <i className="ri ri-car-line" />
                                            </span>
                                            <Input
                                                type="text"
                                                name="marque"
                                                value={searchFilters.marque}
                                                onChange={handleFilterChange}
                                                placeholder="Marque"
                                            />
                                        </div>
                                    </FormGroup>
                                </Col>

                                {/* Modèle */}
                                <Col md={2}>
                                    <FormGroup>
                                        <Label className="small text-muted">Modèle</Label>
                                        <div className="input-group">
                                            <span className="input-group-text bg-light">
                                                <i className="ri ri-car-line" />
                                            </span>
                                            <Input
                                                type="text"
                                                name="modele"
                                                value={searchFilters.modele}
                                                onChange={handleFilterChange}
                                                placeholder="Modèle"
                                            />
                                        </div>
                                    </FormGroup>
                                </Col>

                                {/* Motorisation */}
                                <Col md={2}>
                                    <FormGroup>
                                        <Label className="small text-muted">Motorisation</Label>
                                        <div className="input-group">
                                            <span className="input-group-text bg-light">
                                                <i className="ri ri-car-line" />
                                            </span>
                                            <Input
                                                type="select"
                                                name="motorisation"
                                                value={searchFilters.motorisation}
                                                onChange={handleFilterChange}
                                            >
                                                <option value="">Sélectionner</option>
                                                <option>Essence</option>
                                                <option>Diesel</option>
                                                <option>Hybride</option>
                                                <option>Électrique</option>
                                            </Input>
                                        </div>
                                    </FormGroup>
                                </Col>

                                {/* Immatriculation */}
                                <Col md={2}>
                                    <FormGroup>
                                        <Label className="small text-muted">Immatriculation</Label>
                                        <div className="input-group">
                                            <span className="input-group-text bg-light">
                                                <i className="ri ri-id-card-line" />
                                            </span>
                                            <Input
                                                type="text"
                                                name="immatriculation"
                                                value={searchFilters.immatriculation}
                                                onChange={handleFilterChange}
                                                placeholder="AA-123-BB"
                                            />
                                        </div>
                                    </FormGroup>
                                </Col>

                                {/* Catégorie */}
                                <Col md={2}>
                                    <FormGroup>
                                        <Label className="small text-muted">Catégorie</Label>
                                        <div className="input-group">
                                            <span className="input-group-text bg-light">
                                                <i className="ri ri-list-check" />
                                            </span>
                                            <Input
                                                type="select"
                                                name="categorie"
                                                value={searchFilters.categorie}
                                                onChange={handleFilterChange}
                                            >
                                                <option value="">Toutes</option>
                                                <option>Freinage</option>
                                                <option>Moteur</option>
                                                <option>Suspension</option>
                                                <option>Échappement</option>
                                            </Input>
                                        </div>
                                    </FormGroup>
                                </Col>

                                {/* Search Button */}
                                <Col md={2} className="d-flex align-items-end">
                                    <Button color="primary" className="w-100">
                                        <i className="ri ri-search-line me-2" />
                                        Rechercher
                                    </Button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>

                    {/* Categories Header - Success Color */}
                    <Card className="mb-4 bg-success text-white">
                        <CardBody className="py-2">
                            <div className="d-flex overflow-auto">
                                {categories.map((category, index) => (
                                    <Button
                                        key={index}
                                        color="light"
                                        outline
                                        className={`me-2 d-flex align-items-center ${selectedCategory === category.name ? "active" : ""}`}
                                        onClick={() => setSelectedCategory(category.name)}
                                    >
                                        <span className="me-2">{category.icon}</span>
                                        {category.name}
                                    </Button>
                                ))}
                            </div>
                        </CardBody>
                    </Card>

                    <Row>
                        {/* Brand Filter Column */}
                        <Col md={3}>
                            <Card className="shadow-sm h-80">
                                <CardBody>
                                    <h5 className="mb-3">Filtrer par Marque</h5>
                                    <div className="mb-3">
                                        <Input
                                            type="text"
                                            placeholder="Rechercher une marque..."
                                            className="mb-3"
                                        />
                                    </div>
                                    <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                                        {brandFilters.slice(0, 8).map((brand, index) => (
                                            <div key={index} className="form-check mb-2">
                                                <Input
                                                    type="checkbox"
                                                    id={`brand-${index}`}
                                                    className="form-check-input"
                                                />
                                                <Label
                                                    for={`brand-${index}`}
                                                    className="form-check-label"
                                                >
                                                    {brand}
                                                </Label>
                                            </div>
                                        ))}
                                        {/* Additional brands that will be scrollable */}
                                        {brandFilters.slice(8).map((brand, index) => (
                                            <div key={index + 8} className="form-check mb-2">
                                                <Input
                                                    type="checkbox"
                                                    id={`brand-${index + 8}`}
                                                    className="form-check-input"
                                                />
                                                <Label
                                                    for={`brand-${index + 8}`}
                                                    className="form-check-label"
                                                >
                                                    {brand}
                                                </Label>
                                            </div>
                                        ))}
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>

                        {/* Products Table Column */}
                        <Col md={9}>
                            <Card className="shadow-sm">
                                <CardBody>
                                    <div className="table-responsive">
                                        <Table hover>
                                            <thead>
                                                <tr>
                                                    <th>Marque</th>
                                                    <th>Référence</th>
                                                    <th>Description</th>
                                                    <th>Prix</th>
                                                    <th>Stock</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {products.map((product) => (
                                                    <tr key={product.id}>
                                                        <td>
                                                            <Badge color="primary">{product.marque}</Badge>
                                                        </td>
                                                        <td>{product.reference}</td>
                                                        <td className="text-truncate" style={{ maxWidth: "300px" }}>
                                                            {product.description}
                                                        </td>
                                                        <td className="fw-bold">{product.prix}</td>
                                                        <td>
                                                            {product.stock > 0 ? (
                                                                <Badge color="success">
                                                                    {product.stock} en stock
                                                                </Badge>
                                                            ) : (
                                                                <Badge color="danger">Rupture</Badge>
                                                            )}
                                                            <div className="small text-muted">{product.location}</div>
                                                        </td>
                                                        <td>
                                                            <Button color="primary" size="sm">
                                                                <i className="ri ri-shopping-cart-line me-1" />
                                                                Ajouter au panier
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default ProductSearch;